import { routeTo } from '@brainstud/react-helpers'
// TODO get appRoutes from provider
import { appRoutes } from '@brainstud/react-tbl/features'

export const getNavigation = (navigationIds, navigation, chapters, pages) => {
  return navigationIds.reduce((acc, id) => {
    const item = navigation[id]
    const itemRemap = {
      ...item,
      id: item.prefix,
    }

    switch (item.type) {
      case 'chapter':
        const chapter = chapters[item.chapterId]

        itemRemap.label = chapter.title
        itemRemap.url = routeTo(appRoutes, 'chapter', { chapter: chapter.slug })
        break

      case 'page':
        const page = pages[item.pageId]

        itemRemap.label = page.title
        itemRemap.url = routeTo(appRoutes, 'page', { page: page.slug })
        break

      case 'quiz':
      case 'endtest':
        itemRemap.label = 'Eindtoets'
        itemRemap.url = routeTo(appRoutes, 'endtest')
        break

      default:
    }

    return acc.concat(itemRemap)
  }, [])
}
